/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'

export interface IEmptyCompProps {
  loading?: boolean;
  title?: string;
  subTitle?: string;
}
export default (props: IEmptyCompProps) => {
  const { loading, title, subTitle } = props
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      {loading ? null : t('e_pc_no_data', '暂无数据')}
    </div>
  )
}
